import { app } from '../app';
import { accountFromDto } from '../states/company/user-directories/account.dto';
import { groupFromDto } from '../states/company/user-directories/group.dto';

class GroupsResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getAllCustomAndApplication(companyId) {
        const url = `app/rest/v2/company/${companyId}/groups`;
        return this.$http.get(url).then(({data}) => data);
    }

    getAllCompanyGroups(companyId) {
        const url = `app/rest/v2/company/${companyId}/groups`;
        const params = {type: 'company'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    getGroupById(companyId, groupId) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}`;
        return this.$http.get(url).then(({data}) => data).then(groupFromDto);
    }

    createNewCustomGroup(companyId, name) {
        const url = `app/rest/v2/company/${companyId}/groups`;
        const params = {name};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    deleteGroups(companyId, groupIds) {
        return this
            .$http({
                method: 'DELETE',
                url: `app/rest/v2/company/${companyId}/groups`,
                data: groupIds,
                headers: {'Content-Type': 'application/json'},
            })
            .then(({data}) => data)
    }

    renameGroup(companyId, groupId, groupName) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}/rename`;
        return this.$http.put(url, {groupName}).then(({data}) => data);
    }

    getAllAccountsForCompanyAndEveryoneGroup(companyId) {
        const url = `app/rest/v2/company/${companyId}/groups/everyone/accounts`;
        return this.$http.get(url).then(({data}) => data)
            .then(accounts => accounts.map(accountFromDto))
    }

    getAllAccountsForCompanyAndEveryoneGroupWithPagination(companyId, page, itemPerPage, searchText, sort, reverse) {
        const url = `app/rest/v2/company/${companyId}/groups/everyone/accounts/pagination`;
        return this.$http.post(url, {page, itemPerPage, searchText, sort, reverse}).then(({data}) => data)
    }

    getAllAccountsForCompanyAndGroup(companyId, groupId) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}/accounts`;
        return this.$http.get(url).then(({data}) => data)
            .then(accounts => accounts.map(accountFromDto))
    }

    getAllAccountsForCompanyAndGroupWithPagination(companyId, groupId, page, itemPerPage, searchText, sort, reverse) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}/accounts/pagination`;
        return this.$http.post(url, {page, itemPerPage, searchText, sort, reverse}).then(({data}) => data)
    }

    getAllAccountsForCompanyAndGroupAndApplication(companyId, groupId, appId) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}/${appId}/accounts`;
        return this.$http.get(url).then(({data}) => data);
    }

    addNewUserToGroup(companyId, groupId, username) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}/accounts`;
        return this.$http.post(url, null, {params: {username}}).then(({data}) => data);
    }

    getAssignedApplicationsOfGroup(companyId, groupId) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}/applications`;
        return this.$http.get(url, {params: {type: 'assigned'}}).then(({data}) => data);
    }

    getAssignableApplicationsForGroup(companyId, groupId) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}/applications`;
        return this.$http.get(url, {params: {type: 'unassigned'}}).then(({data}) => data);
    }

    unassignGroupFromApplications(companyId, groupId, applicationIds) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}/applications`;
        const params = {action: 'unassign'};
        return this.$http.post(url, applicationIds, {params}).then(({data}) => data);
    }

    assignGroupToApplication(companyId, groupId, applicationIds) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}/applications`;
        const params = {action: 'assign'};
        const data = applicationIds.map((applicationId) => ({applicationId}));
        return this.$http.post(url, data, {params}).then(({data}) => data);
    }

    getApplicationGroupAccountCredentials(companyId, groupId, appId) {
        const url = `app/rest/v2/company/${companyId}/groups/${groupId}/${appId}/accountcredentials`;
        return this.$http.get(url).then(({data}) => data);
    }
}

app.service('GroupsResource', GroupsResource);



// WEBPACK FOOTER //
// ./src/portal/rest/GroupsResource.js